export default {
  // 共享空间
  ysApplicationList: [
    {
      title: "关于共享空间",
      img: "img_kongjian1",
      content:
        "赢时科技2019年重磅打造“共享空间”，多场景、可定制的商业模式，能够极大地满足用户刚性需求，营造深受用户喜爱的空间氛围。“共享空间”可将空间里的人与人、人与物、物与物有机地链接起来，激发新需求、新体验，从而引领用户消费升级。"
    },
    {
      title: "设备合作模式",
      img: "img_kongjian2",
      content:
        "在“共享空间”内除放置共享洗衣机外，还要引进多种多样的全智能共享设备，满足不同用户在特殊情境下的需求。通过同一个操作应用平台，系统地整合同一个空间内的共享资源，与合作伙伴共享“现金流”、“用户流”、“数据流”。"
    },
    {
      title: "共享使用场景",
      img: "img_kongjian3",
      content:
        "目前“共享空间”已经倾力打造有:共享洗衣&健身空间、共享洗衣&游戏空间、共享洗衣&阅读空间、共享洗衣&美食空间、共享洗衣&阅读空间、共享洗衣&美食空间、共享洗衣&咖啡空间等多个情景应用空间。更多情景的共享空间方案，欢迎联系我们沟通定制！"
    },
    {
      title: "系统优势",
      img: "img_kongjian4",
      content:
        "先进的5GNB-IOT技术、专业技术研发的APP、创新型情景设计、一站式智能体验、定制化服务方案，用户只需下载我们全新研发的APP，即可注册成为会员，选择相应的服务进行体验和享受！"
    }
  ],
  //洗衣模块
  washerModuleList: [
    {
      title: "关于通讯模块",
      img: "w01",
      content:
        "洗衣通讯模组是广州赢时科技于2016年开始联合中国华为、中国电信合作研发的国内首款基于NB-IOT的洗衣机专用物联网通信模组。全球率先采用5GNB-IOT技术，使“共享洗衣”的系统应用更加技术流畅。"
    },
    {
      title: "设备优势",
      img: "w02",
      content:
        ` <div>
        <span>广 覆 盖：</span>
        <span>比现有的网络增益20dB，相当于提升了100倍覆盖区域的能力。</span>
        </div>
          <div>
          <span>稳定联网：</span>
          <span>支撑更大容量连接，保持联网速度快，网络连接稳定。</span>
          </div>
          <div>
          <span>远程管理：</span>
          <span>设备远程管理、维护，降低运维成本，提升效率。</span>
          </div>
          <div>
          <span>信息加密：</span>
          <span>多重加密技术，确保通信链路数据安全。</span>
          </div>
        `
    },
    {
      title: "投放案例",
      img: "w03",
      content:
        "目前赢时科技已经与LG、TCL、小鸭、威力、格力等多个主流品牌的洗衣机完成了对接，截至8月份，无人洗衣房在北上广深，城中村迅速扩展，并在各大公寓、酒店以及多个工厂和学校的宿舍，投放运营了一年多，经历了十几万次的现场用户使用，具有通信稳定，使用方便，成本低等特点"
    },
    {
      title: "合作模式",
      img: "w04",
      content:
        `设备厂商不需要自助研发支付模块，通过赢时科技自主研发的NB-IOT通讯模组跟设备进行对接，即可实现物联网化、移动扫码支付等功能。<br/>
        赢时科技免费提供综合管理平台，合作商可以通过手机或电脑进行实时监控设备运营情况，在多维度报表中查看收益，在订单中心追踪每一笔交易，详尽的数据分析，让合作商能对设备进行精细化管理
        `
    }
  ],

  // app介绍
  APPList: [
    {
      title: "共享洗衣APP",
      children: [
        {
          title: "APP介绍",
          children: [
            {
              title: "五星级体验APP",
              img: "img_pingtai1",
              contents: [
                "共享洗衣APP是赢时科技自主研发的一款便于用户使用共享洗衣机的五星级服务软件。用户可以通过APP预约洗衣、完成在线支付等，全程手机智能控制，洗衣进程尽在掌握，将洗衣流程可视化，给你看得见的安心！"
              ]
            }
          ]
        },
        {
          title: "APP亮点",
          children: [
            {
              title: "一键预约",
              img: "img_pingtai2",
              contents: ["一键预约，醒目编号不会搞错机器"],
              id: "01"
            },
            {
              title: "共享功能",
              img: "img_pingtai11",
              contents: ["独特共享功能，与好友一起享受阳光的味道"],
              id: "02"
            },
            {
              title: "选择一目了然",
              img: "img_pingtai12",
              contents: ["洗衣模式选择页面清晰，洗衣详情一目了然"],
              id: "03"
            },
            {
              title: "语音提醒",
              img: "img_pingtai13",
              contents: ["特有语音提醒功能，温馨提醒，让用户省心操作"],
              id: "04"
            }
          ]
        },
        {
          title: "操作流程",
          children: [
            {
              title: "第一步：扫描机器码",
              img: "img_pingtai3",
              contents: [
                "打开APP扫一扫，扫描设备机器码，或者直接输入设备编码使用。"
              ],
              id: "01",
              url: "0"
            },
            {
              title: "第二步：选择模式，支付下单",
              img: "img_pingtai4",
              contents: ["选择洗衣模式，在线订单付款"],
              id: "02",
              url: "0"
            },
            {
              title: "第三步：进行洗衣，短信提醒取衣",
              img: "img_pingtai5",
              contents: ["完成洗衣，短信提醒"],
              id: "03",
              url: "0"
            },
            {
              title: "第四步：关闭机门，领取共享",
              img: "img_pingtai6",
              contents: [
                "为了下一位使用，及时取衣并关好机门，在APP参与锁门抽奖。"
              ],
              id: "04",
              url: "0"
            }
          ]
        }
      ]
    },
    {
      title: "合作商管理平台",
      children: [
        {
          title: "",
          children: [
            {
              title: "数据详尽，清晰直观",
              img: "img_pingtai7",
              contents: [
                "通过对运营数据详尽的分析，让合作商能对共享洗衣机进行精细管理，助力合作商随时掌握最新运营动态。",
                "数据报表清晰直观，便于合作商随时通过管理平台查看收益，同时方便双方对账等。"
              ]
            }
          ]
        }
      ]
    },
    {
      title: "运营管理平台",
      children: [
        {
          title: "",
          children: [
            {
              title: "轻松管理、运筹帷幄",
              img: "img_pingtai8",
              contents: [
                "设备、订单和收益情况等一目了然，方便运营人员管理共享洗衣机，以及针对各区域洗衣数据策划相关活动。",
                "更有客服根据订单状态回访洗衣用户，及时解决问题并听取反馈，不断改进。"
              ]
            }
          ]
        }
      ]
    },
    {
      title: "监控平台",
      children: [
        {
          title: "",
          children: [
            {
              title: "实时监控、精准营销",
              img: "img_pingtai9",
              contents: [
                "洗衣团队及伙伴可随时在监控平台上看到共享洗衣机在全国的分布情况及其运转状态等，可根据相关数据进行分析，实现区域甚至全国性的精准营销和管理。"
              ]
            }
          ]
        }
      ]
    },
    {
      title: "运维端APP",
      children: [
        {
          title: "",
          children: [
            {
              title: "运维赋能、节约成本",
              img: "img_pingtai10",
              contents: [
                "【共享洗衣运维端APP】是一款适用共享洗衣合作伙伴及运维人员对洗衣机进行日常管理工作的协助软件。",
                "运维人员可通过APP对洗衣机进行安装测试、接受设备异常信息提醒及日常维护等，从而更好地开展日常工作！"
              ]
            }
          ]
        }
      ]
    }
  ],
  // 洗衣机设备
  washerList: [
    {
      title: "LG巨人FAST洗衣机",
      children: [
        {
          title: "产品特色",
          children: [
            {
              title: "",
              img: "LG01",
              contents: [
                "专业的商用洗衣机，经历三次升级，四重减震、六轴陀螺感应、强力波浪、智能泡沫清洁系统。"
              ],
              id: "01"
            },
            {
              title: "四重减震系统，运行更加安静",
              img: "LG02",
              contents: [
                "四重减震器，阻尼强度高，运行起来的噪音低于57分贝，帮助设备运行起来更加平稳，更静音更快速，在商用情况下也不会因为噪音过大而影响用户使用感。"
              ],
              id: "02"
            },
            {
              title: "六轴陀螺感应，洗涤更快速",
              img: "LG03",
              contents: [
                "LG Gyro陀螺平衡系统通过先进的算法提供了优化的平衡性能，可以感应对角线是否平衡，判断更加精准。"
              ],
              id: "03"
            },
            {
              title: "强力波浪系统，滚筒更加洁净",
              img: "LG04",
              contents: [
                "长时间运行的不干净的滚筒会影响洗涤性能。我们的滚筒清洁程序可以帮助你在最繁忙的地方保持干净的滚筒。90℃高温1.5小时。"
              ],
              id: "04"
            },
            {
              title: "直驱变频电机",
              img: "LG05",
              contents: [
                "不同于传统的皮带和滑轮，LG商用洗衣机滚筒直接连接到电机，提供优异的耐久性。更少的零件同样意味着更少修理。"
              ],
              id: "05"
            },
            {
              title: "可定制20个洗涤程序",
              img: "LG06",
              contents: [
                "收费模式：第五个键只能是加强洗净；不收费模式：第五个键设置有20种模式选择。"
              ],
              id: "06"
            },
            {
              title: "可变式控制面板",
              img: "LG07",
              contents: [
                "可变式控制面板让您在节约空间的同时不改变原有容量，而且控制面板保持在可及范围内，并且通用性足以满足您的需要。"
              ],
              id: "07"
            }
          ]
        },
        {
          title: "技术参数",
          children: [
            {
              title: "技术参数",
              img: "LG08",
              contents: [
                "产品型号：LG Giant-C_single washer",
                "滚筒容积：165.6L",
                "正常洗涤转速：40-50RPM",
                "高速脱水转速：1150RPM",
                "重力G值：413G",
                "电量： 220-240/50/15-17.5",
                "噪音等级：62dB(A计权)",
                "产品尺寸：686 × 983 × 767（宽*高*深mm）",
                "使用方式：手机扫码"
              ]
            }
          ]
        }
      ]
    },
    {
      title: "LG巨人FAST烘干机",
      children: [
        {
          title: "产品特色",
          children: [
            {
              title: "",
              img: "LG-k01",
              contents: [
                "烘干速度快效果好，能耗比工业烘干机低，且节能环保。在同样大的空间内，提升烘干容量，可将大量衣物一次性烘干。"
              ],
              id: "01"
            },
            {
              title: "四重减震系统，运行更加安静",
              img: "LG-k02",
              contents: [
                "四重减震器，阻尼强度高，运行起来的噪音低于57分贝，帮助设备运行起来更加平稳，更静音更快速，在商用情况下也不会因为噪音过大而影响用户使用感。"
              ],
              id: "02"
            },
            {
              title: "六轴陀螺感应，洗涤更快速",
              img: "LG-k03",
              contents: [
                "LG Gyro陀螺平衡系统通过先进的算法提供了优化的平衡性能，可以感应对角线是否平衡，判断更加精准。"
              ],
              id: "03"
            },
            {
              title: "直驱变频电机",
              img: "LG-k04",
              contents: [
                "不同于传统的皮带和滑轮，LG商用洗衣机滚筒直接连接到电机，提供优异的耐久性。更少的零件同样意味着更少修理。"
              ],
              id: "04"
            },
            {
              title: "可定制20个洗涤程序",
              img: "LG-k05",
              contents: [
                "不同于传统的皮带和滑轮，LG商用洗衣机滚筒直接连接到电机，提供优异的耐久性。更少的零件同样意味着更少修理。"
              ],
              id: "05"
            },
            {
              title: "可变式控制面板",
              img: "LG-k06",
              contents: [
                "可变式控制面板让您在节约空间的同时不改变原有容量，而且控制面板保持在可及范围内，并且通用性足以满足您的需要。"
              ],
              id: "06"
            }
          ]
        },
        {
          title: "技术参数",
          children: [
            {
              title: "技术参数",
              img: "LG-k07",
              contents: [
                "产品型号：LG Giant-C_Dryer",
                "滚筒容积：207L",
                "加热类型：Electric",
                "烘干类型：直排",
                "加热功率：4600w",
                "电量： 220-240/50/22.5",
                "排风流量：160CFM",
                "产品尺寸：686 × 983 × 764（宽*高*深mm）",
                "使用方式：手机扫码"
              ]
            }
          ]
        }
      ]
    },
    {
      title: "TCL经济型洗衣机",
      children: [
        {
          title: "产品特色",
          children: [
            {
              price: "",
              img: "img_xiyiji7",
              contents: [
                "全新的三代内凸式蜂巢结构内筒，洗涤、脱水极致护衣智能由芯，静享洁净"
              ],
              id: "01"
            },
            {
              title: "洗前桶自洁，卫生有保障",
              img: "img_xiyiji8",
              contents: [
                "洗衣前：超强桶自洁。拒绝交叉感染、二次污染，每次都像用新的洗衣机；",
                "洗衣后：专员清洁。洗衣专员一天至少对洗衣机进行一次清洁消毒，并做好日常洗衣机维护保养工作。"
              ],
              id: "02"
            },
            {
              title: "内凸式蜂巢结构内筒,极致护衣",
              img: "img_xiyiji9",
              contents: [
                "采用最新的三代内凸式蜂巢结构内筒，洗涤、脱水极致护衣智能由芯，静享洁净"
              ],
              id: "03"
            },
            {
              title: "洗衣水量智能调节,不浪费更省钱",
              img: "img_xiyiji10",
              contents: [
                "洗衣机将根据洗衣模式和衣物重量等，智能调节所用水量，有效节约水资源。"
              ],
              id: "04"
            },
            {
              title: "开盖即停,安全有保障",
              img: "img_xiyiji12",
              contents: [
                "洗涤过程中，如果打开盖子，洗衣机会停止运转，防止旋转的内筒伤人，安全有保障。"
              ],
              id: "05"
            },
            {
              title: "手机控制,一键预约，无须排队",
              img: "img_xiyiji13",
              contents: [
                "用户通过“共享洗衣”APP，可以一键预约洗衣，并且全程监控自己的洗衣状态。",
                "洗衣即将完成时用户还会收到短信提醒，方便及时取回衣物。"
              ],
              id: "06"
            }
          ]
        },
        {
          title: "技术参数",
          children: [
            {
              title: "技术参数",
              img: "img_xiyiji14",
              contents: [
                "产品型号：TB-V6001G",
                "电源：220V~/50Hz",
                "进水水压：0.03~1.0)MPa",
                "额定洗涤容量：6.0kg",
                "额定脱水容量：6.0kg",
                "额定洗涤功率：330W",
                "额定脱水功率：270W",
                "洗涤噪音：59dB(A计权)",
                "脱水噪音：69dB(A计权)",
                "能效等级：3级",
                "外形尺寸(mm)：525(宽)X531(深)X860(高)"
              ]
            }
          ]
        }
      ]
    },
    {
      title: "TCL滚筒洗衣机",
      children: [
        {
          title: "产品特色",
          children: [
            {
              price: "",
              img: "TCL01",
              contents: [
                "6SENSE智慧感知一体机，智能安全门锁，“S”型喷淋提升筋，洗衣更护衣"
              ],
              id: "01"
            },
            {
              title: "6 SENSE智慧感知：感应桶内环境",
              img: "TCL02",
              contents: ["感应桶内环境，匹配相应的水位、温度、转速等"],
              id: "02"
            },
            {
              title: "一体成型箱体",
              img: "TCL03",
              contents: ["洗衣机箱体由一整张钢板曲压而成，静音耐用。"],
              id: "03"
            },
            {
              title: "内凸式蜂巢结构内筒",
              img: "TCL04",
              contents: ["内凸式蜂巢结构内筒，洗衣更护衣。"],
              id: "04"
            },
            {
              title: "“S”型喷淋提升筋",
              img: "TCL05",
              contents: ["拥有更准确的抓举力，更低的磨损率。"],
              id: "05"
            },
            {
              title: "大幅提升内径，缩减筒深",
              img: "TCL06",
              contents: [
                "505MM加宽筒径，290mm薄款筒深。",
                "大幅提升内径，缩减筒深，摔打更彻底，衣物更洁净。"
              ],
              id: "06"
            },
            {
              title: "95°C高温自洁杀菌",
              img: "TCL07",
              contents: [
                "物理高温自洁方式，保持干净洗衣空间；无任何化学残留，告别洗衣二次污染！"
              ],
              id: "07"
            }
          ]
        },
        {
          title: "技术参数",
          children: [
            {
              title: "技术参数",
              img: "TCL08",
              contents: [
                "产品型号：TCL TGM-V8010BG(YS)",
                "额定电源：220V~/50HZ",
                "额定洗涤容量：8.0KG",
                "额定脱水容量：8.0KG",
                "额定洗涤功率：80W",
                "额定脱水功率：360W",
                "进水水压：(0.05~0.8)MPa",
                "洗涤噪音：62dB(A计权)",
                "脱水噪音：72dB(A计权)",
                "能效等级：1级",
                "洗衣机外形尺寸：595 × 540 × 850（mm）",
                "使用方式：手机扫码、NFC刷卡、扫码+刷卡"
              ]
            }
          ]
        }
      ]
    },
    {
      title: "小鸭洗衣机",
      children: [
        {
          title: "产品特色",
          children: [
            {
              title:"",
              img: "img_xiyiji1",
              contents: [
                "全自动洗烘除菌一体机，",
                "安全智能锁，“锁”住衣物安全。"
              ],
              id: "01"
            },
            {
              title: "超强桶自洁，卫生有保障",
              img: "img_xiyiji2",
              contents: [
                "预洗清洁，洗衣更卫生，更放心。利用内桶高速旋转产生激荡水流冲洗内桶，从而保持内外桶清洁。"
              ],
              id: "02"
            },
            {
              title: "臭氧除菌，全程伴随",
              img: "img_xiyiji3",
              contents: [
                "超能活氧除菌，衣物充满阳光的味道。通过超能活氧发生器产生超能活氧，渗透到衣物每个角落，抑菌除异味。"
              ],
              id: "03"
            },
            {
              title: "在线预约，方便快捷",
              img: "img_xiyiji4",
              contents: [
                "通过手机APP或者小程序在线预约空闲洗衣机，无须排队费时等候。"
              ],
              id: "04"
            },
            {
              title: "智能门锁，随时取衣",
              img: "img_xiyiji6",
              contents: [
                "人性化设计门锁，智能掌控，坚实牢固；只有用户本人通过APP才能操作开关门，保证衣物安全。"
              ],
              id: "05"
            },
            {
              title: "自动传感烘干功能",
              img: "img_xiyiji5",
              contents: [
                "“衣干即停”，“即洗即穿”。小鸭多点立体测温技术，科学布局感温触点，360°全方位多角度捕捉衣物温度变化，准确控制烘干时间。"
              ],
              id: "06"
            }
          ]
        },

        {
          title: "技术参数",
          children: [
            {
              title: "技术参数",
              img: "img_xiyiji6",
              contents: [
                "产品型号：XQG70-CA71610HG/W",
                "额定容量：7.0kg(洗涤)/3.5kg(烘干)",
                "额定电源：220-240V~,50/60Hz",
                "额定洗涤功率：150W",
                "额定脱水功率：300W",
                "洗涤加热功率：1900W",
                "烘干加热功率：1300W",
                "最高脱水转速：1000rpm",
                "洗衣机外形尺寸：(长X宽X高)：600X550X850(mm)",
                "洗衣机净重：73kg",
                "洗涤剂投放箱外形尺寸：(长X宽X高)：450X180X350(mm)"
              ]
            }
          ]
        }
      ]
    }
  ],
  // 合作案例
  caseList: [
    {
      img: "img_hezuo1",
      title: "富士康科技集团",
      content:
        "2018年10月30日，富士康龙华园区的“闪Q空间”开始运营。高大上的共享“闪Q空间”，能极大地提升富士康的企业形象。“共享洗衣”重磅助力富士康，为员工带去高品质的洗衣服务，共享生活新姿态！",
      time: "2018.10.30",
      id: "1",
      url: "https://mp.weixin.qq.com/s/GFySX5V__t1X3YmFrmOcgw",
      height: "5660"
    },
    {
      img: "img_hezuo2",
      title: "江门中医药职业学院",
      content:
        "2018年5月2日，“共享洗衣”在江门中医院职业学院开始试运营。我们与学院学生会达成共识，结合双方的资源平台，进行最大化的合作与互助互惠，从而让“共享洗衣”能够为学生提供最佳的服务体验。",
      time: "2018.05.02",
      id: "2",
      url: "https://mp.weixin.qq.com/s/Y-GQg3oPru_epgnIqollTg",
      height: "9275"
    },
    {
      img: "img_hezuo3",
      title: "泓雅洗衣",
      content:
        "2018年11月24日，泓雅洗衣的两间无人洗衣房在深圳隆重开业！早前，泓雅科技与赢时科技签署了关于“共享洗衣”项目的商务合作协议，计划以广东深圳为主，围绕着城中村展开铺设，打造1000间无人洗衣房……",
      time: "2018.11.24",
      id: "3",
      url: "https://mp.weixin.qq.com/s/UJwx6nqVGym-04hQIgZ6hg",
      height: "4728"
    },
    {
      img: "img_hezuo4",
      title: "锦江都城酒店",
      content:
        "12月20日，“共享洗衣”与锦江都城酒店达成战略合作。酒店引入“共享洗衣”，可以最大限度地为客户提供五星级服务，提升酒店的品牌形象；而对住客来说，出门住酒店，再也不用担心洗衣晾衣难的问题了！",
      time: "2018.12.20",
      id: "4",
      url: "https://mp.weixin.qq.com/s/kTE3zTqeNirYxXCzaHQ5oQ",
      height: "5710"
    },
    {
      img: "img_hezuo5",
      title: "江门雅图仕",
      content:
        "2018年6月22日，“共享洗衣”正式入驻雅图仕，这是短短几个月里“共享洗衣”在江门多地优秀试点以来又一次创举！雅图仕和我们合作，让上万员工能在解放双手的同时，享受高品质、低价格的洗衣服务！",
      time: "2018.06.22",
      id: "5",
      url: "https://mp.weixin.qq.com/s/eloe0Equ1XHQrdBH5L656w",
      height: "4601"
    },
    {
      img: "img_hezuo6",
      title: "江职新宁学院",
      content:
        "2018年5月15日，“共享洗衣”来到了江门职业技术学院新宁学院。“共享洗衣”在新宁学院出现，无疑为同学提供了一次“偷懒”的机会。从此同学们洗衣服不但省心省钱更省力，还可以有更多的时间学习和娱乐！",
      time: "2018.05.15",
      id: "6",
      url: "https://mp.weixin.qq.com/s/mhA79p2Flk9swE2Z1fxI9w",
      height: "5240"
    }
  ],
  // 热点新闻
  newList: [
    {
      img: "img_new1",
      title: "“共享洗衣”产品发布会",
      bgTitle: "",
      content:
        "2018年9月13日，“共享洗衣”产品发布会在广州·广交会展馆隆重举行。赢时科技特别邀请了各行业领导、全国各地的代理商以及媒体代表出席了本次发布会，共同见证“共享洗衣”这一重要的历史性时刻。",
      time: "2018.09.13",
      url: "https://mp.weixin.qq.com/s/wehnV3SrBwj22uPIJkW5hA",
      height: "5770",
      id: "1"
    },
    {
      img: "img_new2",
      title: "多家知名媒体报道产品发布会",
      content:
        "“共享洗衣”产品发布会受到包括：珠江频道——今日财经频道、新快报、搜狐网、中国日报网、凤凰网、中华网、消费日报网、今日头条、南方网科技、中国科学网、新浪财经头条等主流媒体和门户网站的关注和报道……",
      time: "2018.09.13",
      id: "2",
      url: "https://mp.weixin.qq.com/s/e-gn0TDlfm4u_L1pcShxeA",
      height: "7180"
    },
    {
      img: "img_new3",
      title: "第五届广州国际物联网展览会",
      content:
        "2018年9月26-28日，“共享洗衣”参加了2018第五届广州国际物联网展览会，接待了来自全国各地的行业领导和客户，“共享洗衣”吸引了大量参观人员，更有一些客户现场就与我司进行了项目现场签约。",
      time: "2018.09.28",
      id: "3",
      url: "https://mp.weixin.qq.com/s/uMznFm6M9KnNMviWvE1w5w",
      height: "4250"
    },
    {
      img: "img_new4",
      title: "校企联合强强联手",
      content:
        "2018年1月31日，广东省人力资源研究会、广东省校企合作促进会与校校合作促进会授予赢时科技“副会长单位”。我们得到了校企联合会领导一致好评，同时他们表示会全力支持“共享洗衣”惠民经济项目的推广……",
      time: "2018.10.31",
      id: "4",
      url: "https://mp.weixin.qq.com/s/6p_oTerWylm4BRv77KshGQ",
      height: "4385"
    },
    {
      img: "img_new5",
      title: "陕西省大学生创业节",
      content:
        "2018年11月10日,陕西大学生的创业狂欢节——陕西省第六届“鱼化龙”大学生创业节在西安外事学院开幕。“共享洗衣”受邀参加了本届大学生创业节，我们的展位受到了众多领导、嘉宾和师生的高度关注。",
      time: "2018.11.10",
      id: "5",
      url: "https://mp.weixin.qq.com/s/nwqUoJnN1IaIbEF8fCHMOA",
      height: "5006"
    },
    {
      img: "img_new6",
      title: "香港天水围官立中学为共享洗衣点赞",
      content:
        "2018年6月11日，香港天水围官立中学和“共享洗衣”友好交流活动顺利举行。本次活动旨在向香港教师们介绍“共享洗衣”项目，让他们对内地的共享经济有清晰认知，并为我们日后进入香港市场打下良好基础。",
      time: "2018.06.11",
      id: "6",
      url: "https://mp.weixin.qq.com/s/Meg31fF1mPq1kZJFwvgNoA",
      height: "6188"
    }
  ],
  // 关于我们
  aboutUsOne: [
    {
      type: "one",
      img: "img_bg_lianjieshenghuo",
      title: "赢时科技，链接生活",
      paragraph: [
        {
          title: "",
          content:
            "广东赢时科技有限公司成立于2014年，总部位于广东东莞，公司在硅谷、广州设有研发机构和大数据分析处理中心。"
        },
        {
          title: "",
          content:
            "2015年赢时科技在美国成功申请注册了“看广告得共享”创新型商业模式专利，该项专利受到（包括中国在内）全球140多个国家的承认及保护。"
        },
        {
          title: "",
          content:
            "据此核心专利，公司致力于研发“广告所见即所得”全球首创的消费者“关注度”广告媒体交易平台————即“共享”。"
        }
      ]
    },
    {
      type: "two",
      img: "img_bg_yingxiao",
      title: "DSP精准营销",
      paragraph: [
        {
          title: "",
          content:
            "通过系统捕捉消费者对广告媒体的“关注度”精准评估广告媒体投放的效果及性价比，同时将消费者关注的商业信息贴上标签，通过DSP将广告精准地推送给有潜在需求的消费者。过程中采用随机激励的方式引导消费者主动选择自己所关注的广告消息。让消费者的个人时间更有价值；让广告主的广告费更加有效；让媒体运营商的媒体形式更为靠谱。"
        },
        {
          title: "",
          content:
            "赢时科技拥有专业的系统架构和平台设计、开发实施、大数据分析处理的技术能力和项目经验。"
        },
        {
          title: "",
          content:
            "2017 年公司自主研发的消费者“关注度”广告媒体交易平台“共享”已正式上线，其依托大数据分析及实时处理，对展示广告模式进行精准量化，提高数字广告投放效益，支持投屏、跨媒体投放。"
        }
      ]
    },
    {
      type: "one",
      img: "img_bg_xiangmu",
      title: "多个垂直领域项目",
      paragraph: [
        {
          title: "",
          content:
            "赢时科技以“共享”——消费者“关注度”广告媒体交易平台为核心，公司已建立以实时数据平台为核心的多个赢时特色的垂直领域的项目：共享电源、共享洗衣、共享复印项目应用，打造符合中国特色的“共享经济生态圈”，未来也逐步推进平台应用项目的市场化、资本化，打造赢时特色的共享经济业务生态系统。"
        }
      ]
    },
    {
      type: "two",
      img: "img_bg_jingzhengli",
      title: "核心竞争力",
      paragraph: [
        {
          title: "富有创造力的团队",
          content:
            "公司团队成员主要来自于BAT及美国硅谷知名互联网企业，是一个极富创造力和凝聚力的团队，整个团队致力于创造“五星级的服务”，为城市打造全新洗衣体验。"
        },
        {
          title: "强大充沛的资源关系网",
          content:
            "赢时科技与南方电网、小鸭集团、中国电信及四川长虹等国内知名企业达成了战略合作伙伴关系，融合了移动互联网、通讯模块及专业硬件生产商的强大基因。当物联网时代来临，赢时科技的新技术与运营的结合必将开创互联网行业的新纪元。"
        },
        {
          title: "坚固可靠的后盾",
          content:
            "赢时科技专注数据技术，在技术服务平台拥有专业而成熟的核心技术，我们将用技术以及独到的市场判断，支持和孵化有梦想、有前景的伙伴。"
        }
      ]
    },
    {
      type: "one",
      img: "img_bg_shangyemoshi",
      title: "商业模式",
      paragraph: [
        {
          title: "",
          content:
            "我们率先采用领先全球的5G/NB-loT通讯模块，结合大数据云平台，让系统反应更快更流畅，地图定位更准确。"
        },
        {
          title: "",
          content:
            "坚持“化繁为简，全能贴心，极致生活”的目标，打造研发、商务、售后到运营一条路的物联网产业链，以公共洗衣机、租赁洗衣机、洗衣房为项目核心，发展三种全新的商业发展模式。"
        },
        {
          title: "",
          content:
            "通过打造“最严格的卫生保障公共洗衣机、最经济的租赁洗衣机、最极致体验的洗衣房”，让无论消费者还是合作商户，都能真正享受到共享经济带来的生活飞跃和经济自由。"
        }
      ]
    }
  ],
  // 共享洗衣
  laundry: [
    {
      type: "two",
      img: "img_xiangmuyuanqi",
      title: "项目缘起",
      paragraph: [
        {
          title: "",
          content:
            "洗衣是一种生活态度，更是一种意识形态，人类自石器时代就开始通过洗涤衣物来对抗“跳蚤”与“疾病”。随着时代的进化，人类从用手洗衣物到使用洗衣机洗衣有了质的飞跃，让人类的双手从繁复的洗衣劳动中得以解放。"
        },
        {
          title: "",
          content:
            "“时代”是“文明”日新月异迭代的过程，而今的互联网、人工智能、物联网技术高速的发展，洗衣生活的意识形态在悄然发生变化，高端全智能洗衣机不再是平民百姓遥不可及的物件。一种新兴的共享经济模式，让高质量的洗衣生活慢慢普及。"
        }
      ]
    },
    {
      type: "course",
      img: "img_bg_fazhan2",
      title: "发展历程",
      paragraph: [
        {
          year: "2019",
          no2016: [
            {
              title: "",
              time: "8月",
              content: "共享洗衣与LG集团达成战略合作，为LG洗衣门店提供赢时平台作为官方唯一平台"
            }
          ]
        },
        {
          year: "2018",
          no2018: [
            // {
            //   title: "",
            //   time: "12月",
            //   content: "共享洗衣重磅打造“共享空间”"
            // },
            {
              title: "",
              time: "11月",
              content: "共享洗衣携手TCL集团，推出经济型洗衣机、滚筒洗衣机"
            },
            {
              title: "",
              time: "10月",
              content: "与泓雅洗衣签订协议，共同打造无人洗衣房"
            },
            {
              title: "",
              time: "9月",
              content: "共享洗衣产品发布会在广州·广交会展馆隆重举行"
            },
            {
              title: "",
              time: "7月",
              content:
                "与世界五百强某集团达成合作；10月，全国厂区共享洗衣搭建并开始运营"
            },
            {
              title: "",
              time: "2月",
              content: "共享洗衣江门代理商授权仪式举行"
            },
            {
              title: "",
              time: "1月",
              content:
                "共享洗衣正式推出市场。该月底，广东省人力资源研究会、广东省校企合作促进会与校校合作促进会授予广东赢时科技有限公司“副会长单位”"
            }
          ]
        },
        {
          year: "2017",
          no2017: [
            {
              title: "",
              time: "12月",
              content: "共享洗衣全面上线，与小鸭集团召开新闻发布会"
            },
            {
              title: "",
              time: "11月",
              content: "与中国电信达成5G/NB-IoT通讯模块战略合作协议"
            },
            {
              title: "",
              time: "8月",
              content: "共享洗衣物联网洗衣机内测成功"
            },
            // {
            //   title: "",
            //   time: "5月",
            //   content: "共享洗衣第一代物联网洗衣机内测成功"
            // },
            {
              title: "",
              time: "1月",
              content:
                "与山东小鸭集团达成战略合作关系，双方共同投入研发智慧型物联网商业洗衣机"
            }
          ]
        },
        {
          year: "2016",
          no2016: [
            {
              title: "",
              time: "12月",
              content: "共享洗衣项目启动"
            }
          ]
        }
      ]
    },
    {
      type: "two",
      img: "cj",
      title: "取得成就",
      paragraph: [
        {
          title: "",
          content: "赢时科技通过自主研发，使“共享洗衣”获得业内多个“第一”："
        },
        {
          title: "",
          content: "国内首家采用5G通信模组，物联网化让洗衣过程更顺畅、更稳定；"
        },
        {
          title: "",
          content: "第一个采用智能安全锁，极大程度地保障您的衣物的“安全问题”;"
        },
        {
          content:
            "第一个采用洗涤、除菌、洗烘一体机，一站式洗衣体验，省心更省事;",
          title: ""
        },
        {
          content:
            "第一个采用自助式投放洗衣液、柔顺剂，给衣物带去更细腻的呵护;",
          title: ""
        },
        {
          content:
            "第一个通过APP将洗衣流程可视化，洗衣进程尽在掌握，看得见的安心;",
          title: ""
        },
        {
          content:
            "第一个通过“共享”广告趣味互动，让用户获得更多实惠，越洗越经济......",
          title: ""
        }
      ]
    }
  ],
  // 首页应用场景
  accordionList: [
    {
      img: "img_xuexiao",
      headline: "学校", // 大标题
      title: "共享洗衣为学校赋能", // 标题
      subhead: "Shared laundry empowers the school", // 副标题
      description: [
        "有效提升学校品牌形象",
        "有效节约学生课余时间",
        "有效降低学校洗衣水电成本",
        "有效降低学校维护公共洗衣机成本",
        "为学校提供学生洗衣生活行为大数据"
      ], // 描述
      min:
        "校园的形象建设已不再是仅仅停留在设施建设上，还追求高品质的校园生活配套。“共享洗衣”的出现既提升了校园的品质，又能方便学生洗衣，有效节约学生课余时间。"
    },
    {
      img: "img_gongchang2",
      headline: "工厂", // 大标题
      title: "共享洗衣为工厂员工提供便捷服务", // 标题
      subhead:
        "Sharing Laundry to Provide Convenient Service for Factory Staff", // 副标题
      description: [
        "“共享洗衣”入驻工厂园区，能美化厂容厂貌，提升企业形象",
        "五星级洗衣机让员工拥有五星级的家，增强工人的归属感",
        "解放工人的双手，让他们工作之余有更多时间享受生活"
      ], // 描述
      min:
        "工厂园区里购置共享洗衣机，能够解放工人的双手，让他们不被繁杂的洗衣劳动所累。工人们在一天的工作之余，可以有更多时间享受生活，增强他们对工厂的归属感。 "
    },
    {
      img: "img_jiudian",
      headline: "酒店", // 大标题
      title: "共享洗衣提升商务酒店市场竞争力", // 标题
      subhead:
        "Sharing Laundry to Improve Market Competitiveness of Business Hotels", // 副标题
      description: [
        "为住客提供高品质的洗衣服务，彰显服务品质",
        "洗烘一体的“共享洗衣机”，给住客提供高效差旅支持",
        "酒店式“共享洗衣房”可增强住客宾至如归的情景体验",
        "“共享洗衣”可成为酒店特色增值服务项目"
      ], // 描述
      min:
        "酒店式共享洗衣房，可成为酒店特色增值项目，提升酒店星级竞争力。既能为宾客提供高品质的洗衣服务，解决差旅人士衣物换洗需求，还可以增强住客宾至如归的情景体验。"
    },
    {
      img: "img_chengzhongcun",
      headline: "城中村", // 大标题
      title: "共享洗衣让租客节约时间和空间成本", // 标题
      subhead: "Sharing laundry to save time and space costs for tenants", // 副标题
      description: [
        "有了共享洗衣机，租客不用自己买，可以省下采购成本还能节约空间",
        "方便人们清洗家中不便晾晒的床单、被套等，还能烘干，省时省事",
        "可在城中村打造“共享空间”，让人们除了洗衣，更能休闲社交"
      ], // 描述
      min:
        "城中村里有了共享洗衣机，租客不用自己买，可以省下采购成本，还能节约空间。洗烘一体的共享洗衣机，既能方便人们清洗家中不便晾晒的床单、被套等，还能及时烘干，省时省事。"
    },
    {
      img: "img_gongyu",
      headline: "公寓", // 大标题
      title: "共享洗衣极大完善公寓形象建设", // 标题
      subhead:
        "Sharing laundry greatly improves the building of apartment image", // 副标题
      description: [
        "高品质的共享洗衣，能让公寓的形象建设更加完善",
        "有效节省小型公寓的空间，让住房面积满足住客需要",
        " 住客既可在共享洗衣房里洗衣，还能休闲娱乐，放松身心"
      ], // 描述
      min:
        "高品质的共享洗衣房，既能极大完善公寓形象建设，还能有效节省小型公寓的空间，让住房面积满足住客需要。住客既可在共享洗衣房里洗衣，还能休闲娱乐，放松身心。"
    }
  ]
};



// WEBPACK FOOTER //
// ./src/libs/ys-data.js